import axios from 'axios';
import mem from "mem";
import axiosInstance from '../../utils/axios';
import * as url from "../../utils/urls";
import { loadData, saveData } from '../../utils/localStorage';
import { toast } from 'react-toastify';
import { ERROR, SERVER_ERROR } from "../../constant/constants";


const maxAge = 10000;
const historyId = JSON.parse(loadData("user"))?.history_id;


export const loginService = async (data, queryParams) => {

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return axios.post(`${url.getUserLoggedInUrl}?${queryParamsList}`, data)
  }
  catch (error) {
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
};


export const signUpService = async (data, queryParams) => {

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return axios.post(`${url.getCustomerSignUpUrl}?${queryParamsList}`, data)
  }
  catch (error) {
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
};


export const LogoutService = async (data, queryParams) => {

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.post(`${url.getUserLogOutUrl}?${queryParamsList}`, data)
    .then((response) => {
      return response.data;
    }).catch((error) => {
      const data = error.response.data;
      toast.error(data.message[0]);
      if (data.status_code === 401) {
        return ERROR;
      }
      return data;
    })
  }
  catch (error) {
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
};


const getRefreshTokenService = async (queryParams) => {
  
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.post(`${url.getAccessTokenUrl}?${queryParamsList}`, {})
      .then((response) => {
        saveData("access", response.data.data.token.access);
        saveData("refresh", response.data.data.token.refresh);
        return response.data.data.token;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}
export const memRefreshTokenService = mem(getRefreshTokenService, {maxAge});

export const forgotPasswordService = async (data, queryParams) => {
  
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return axios.post(`${url.getForgotPasswordUrl}?${queryParamsList}`, data)
  }
  catch (error) {
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
};

export const resetPasswordService = async (data, queryParams) => {

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.patch(`${url.getResetPasswordUrl}?${queryParamsList}`, data)
      .then((response) => {
        toast.success(response.data.message[0]);
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
};

export const ChangePasswordService = async (data, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key, index) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.patch(`${url.getChangePasswordUrl}?${queryParamsList}`, data)
      .then((response) => {
        toast.success(response.data.message[0]);
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const academicCourseListService = async (queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getAcademicCourseListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const getAcademicCourseService = async (slug_name, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getAcademicCourseUrl}/${slug_name}/?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const getAcademicLessonService = async (slug_name, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getAcademicLessonUrl}/${slug_name}/?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const saveCourseLessonProgressService = async (data, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.post(`${url.saveCourseLessonProgressUrl}?${queryParamsList}`, data)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const getStudentProfileService = async (queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);
  
  try {
    return await axiosInstance.get(`${url.getStudentProfileUrl}?${queryParamsList}`, {})
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  } 
};

export const getSchoolAdminProfileService = async (queryParams) => {
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);
  
  try {
    return await axiosInstance.get(`${url.getSchoolAdminProfileUrl}?${queryParamsList}`, {})
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  } 
};

export const getCountryService = async (queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getCountryListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}


export const getStateService = async (queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getStateListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const getCityService = async (queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getCityListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const editProfileService = async (userId, data, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.patch(`${url.getEditProfileUrl}/${userId}/?${queryParamsList}`, data)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const updateSchoolAdminProfileService = async (data, queryParams) => {
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);
  
  try {
    return await axiosInstance.patch(`${url.updateSchoolAdminProfileUrl}?${queryParamsList}`, data)
      .then((response) => {
        toast.success(response.data.message[0]);
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  } 
};

export const downloadCertificateService = async (userId, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getDownloadCertificateUrl}/${userId}/?${queryParamsList}`, {
      responseType: "blob"
    });
  } catch (error) {
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const getAttendanceListService = async (queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);
  
  try {
    return await axiosInstance.get(`${url.getAttendanceListUrl}?${queryParamsList}`, {})
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const getAdminAttendanceListService = async (queryParams) => { 
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getAdminAttendanceListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const getAdminAttendanceSummaryListService = async (queryParams) => { 
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getAdminAttendanceSummaryUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const CreateStudentProfileService = async (userId, data, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.patch(`${url.CreateStudentProfileUrl}/${userId}/?${queryParamsList}`, data)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}


export const getNeFestPaymentListService = async (queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axios.get(`${url.getNefPaymentListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const IITBombayTechfestListingListService = async (queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axios.get(`${url.iitBombayFestListingUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const getNefSubmissionVerifyService = async (data, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axios.post(`${url.getNefSubmissionVerifyUrl}?${queryParamsList}`, data)
      .then((response) => {
        toast.success("Verification successful.");
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}


export const getNefSubmissionService = async (id, data, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axios.patch(`${url.getNefSubmissionUrl}/${id}/?${queryParamsList}`, data)
      .then((response) => {
        toast.success(response.data.message[0]);
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const getUploadFileUrlService = async (data, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axios.post(`${url.getUploadSignedUrl}?${queryParamsList}`, data)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const getClassListService = async (queryParams) => { 
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getClassListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const getSectionListService = async (queryParams) => { 
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getSectionListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const getSessionListService = async (queryParams) => { 
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getSessionListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const getStudentListService = async (queryParams) => {
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getStudentListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const getSchoolTeacherListService = async (queryParams) => {
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getSchoolTeacherListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const saveTeacherService = async (data, queryParams) => { 
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.post(`${url.getAddTeacherUrl}?${queryParamsList}`, data)
      .then((response) => {
        toast.success(response.data.message[0], {
          position: toast.POSITION.TOP_RIGHT,
        });
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}


export const getCompletedTopicsListService = async (queryParams) => {
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getCompletedTopicListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}


export const getSchoolAdminDashboardService = async (queryParams) => {
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getSchoolAdminDashboardUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}


export const saveIITBombayFestService = async (data, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axios.post(`${url.saveIITBombayFestUrl}?${queryParamsList}`, data)
      .then((response) => {
        toast.success("Registration Successfully, Our Team will contact you.");
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}


export const downloadIITBombayFestService = async (data, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);
  
  try {
    return await axios.post(`${url.downloadIITBombayFestUrl}?${queryParamsList}`, data, {
        responseType: 'blob'
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'certificate.png'); 
        document.body.appendChild(link);
        link.click();
        return {
          status_code: 200
        }

      }).catch((error) => {
        toast.error("You do not have permission to access.");
        return {
          status_code: 400
        };
      })
    
  } catch (error) { 
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}


export const BookListService = async (queryParams) => {
  
  let axiosObj = axios;
  console.log("history id in book list service:", historyId);
  if (historyId){
    
    queryParams["history_id"] = historyId;
    axiosObj = axiosInstance;
  }

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return axiosObj.get(`${url.getBooksListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
  }
  catch (error) {
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
};

export const BookDetailsService = async (bookSlug, queryParams) => {

  let axiosObj = axios;
  console.log("history id in book list service:", historyId);
  if (historyId){
    
    queryParams["history_id"] = historyId;
    axiosObj = axiosInstance;
  }

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return axiosObj.get(`${url.getBooksDetailsUrl}/${bookSlug}/?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
  }
  catch (error) {
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
};

export const bookAddToCartService = async (data, queryParams) => {
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.post(`${url.getBooksAddToCartUrl}?${queryParamsList}`, data)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const bookCartListService = async (queryParams) => {
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getBooksCartListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}


export const bookRemoveCartService = async (bookId, queryParams) => {
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.delete(`${url.getBooksRemoveCartUrl}/${bookId}/?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const bookCheckoutUserListService = async (queryParams) => {
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getBooksCheckoutUserListUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const bookOrderCreateService = async (data, queryParams) => {
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.post(`${url.getBooksOrderCreateUrl}?${queryParamsList}`, data)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}


export const bookOrderVerifyPaymentService = async (data, queryParams) => {
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.post(`${url.getBooksOrderVerifyUrl}?${queryParamsList}`, data)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const bookOrderFailureService = async (data, queryParams) => {
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.post(`${url.getBooksOrderFailureUrl}?${queryParamsList}`, data)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}


export const bookOrderRetryService = async (orderId, data, queryParams) => {
  //saving login history id.
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.post(`${url.getBooksOrderRetryUrl}/${orderId}?${queryParamsList}`, data)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const bookLibraryPurchasedListService = async (queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getBooksLibraryPurchasedUrl}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const bookPurchasedDetailService  = async (bookIdentifier, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getBooksLibraryPurchasedUrl}/${bookIdentifier}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const bookProgressService = async (bookId, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getBooksPurchasedProgressUrl}/${bookId}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const bookLessonSlidesService = async (bookId, lessonId, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getBooksLessonSlidesUrl}/${bookId}/lessons/${lessonId}/slides?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const bookSlideProgressUpdateService = async (bookId, lessonId, slideId, data, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.post(`${url.getBooksLessonSlidesUrl}/${bookId}/lessons/${lessonId}/slides/${slideId}/progress?${queryParamsList}`, data)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const bookBookmarkListService = async (bookId, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getBooksBookmarksUrl}/${bookId}/bookmarks?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const createBookBookmarkService = async (bookId, lessonId, data, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.post(`${url.getBooksBookmarksUrl}/${bookId}/lessons/${lessonId}/bookmarks?${queryParamsList}`, data)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const deleteBookBookmarkService = async (bookmarkId, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.delete(`${url.getBooksBookmarkDeleteUrl}/${bookmarkId}/delete?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const bookNoteListService = async (bookId, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getBooksNotesUrl}/${bookId}/notes?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const createBookNoteService = async (bookId, data, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.post(`${url.getBooksNotesUrl}/${bookId}/notes/create?${queryParamsList}`, data)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const updateBookNoteService = async (noteId, data, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.patch(`${url.getBooksNoteUpdateUrl}/${noteId}/update?${queryParamsList}`, data)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const deleteBookNoteService = async (noteId, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.delete(`${url.getBooksNoteUpdateUrl}/${noteId}/delete?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}


export const bookReviewsService = async (bookId, queryParams) => {
  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.get(`${url.getBooksPurchasedReviewUrl}/${bookId}?${queryParamsList}`)
      .then((response) => {
        return response.data;

      }).catch((error) => {
        const data = error.response.data;
        toast.error(data.message[0]);
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      })
    
  } catch (error) { 
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const createBookReviewService = async (data, queryParams) => {
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.post(`${url.getBooksCreateReviewUrl}?${queryParamsList}`, data)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        const data = error.response.data;
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      });
  } catch (error) {
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const updateBookReviewService = async (reviewId, data, queryParams) => {
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.patch(`${url.getBooksUpdateReviewUrl}/${reviewId}/update?${queryParamsList}`, data)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        const data = error.response.data;
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      });
  } catch (error) {
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}

export const deleteBookReviewService = async (reviewId, queryParams) => {
  queryParams["history_id"] = historyId;

  let queryParamsList = "";
  Object.keys(queryParams).map((key) => queryParamsList += "&" + key + "=" + queryParams[key]);

  try {
    return await axiosInstance.delete(`${url.getBooksUpdateReviewUrl}/${reviewId}/delete?${queryParamsList}`)
      .then((response) => {
        return response.data;
      }).catch((error) => {
        const data = error.response.data;
        if (data.status_code === 401) {
          return ERROR;
        }
        return data;
      });
  } catch (error) {
    console.log(error);
    toast.error(SERVER_ERROR);
    return ERROR;
  }
}
